import React from 'react';
import { Box } from '@mui/material';

export const BRAND_NAME = 'BacchaPanti';
export const BRAND_LOGO_SRC = `${process.env.PUBLIC_URL || ''}/BacchapantiLogo.png`;

export default function BrandLogo({ height = 88, alt = BRAND_NAME, sx }) {
  const size = typeof height === 'number' ? height : 88;
  return (
    <Box
      component="img"
      src={BRAND_LOGO_SRC}
      alt={alt}
      ref={(node) => {
        // Box treats width and height props as CSS, so the HTML attributes
        // have to be set on the image element itself.
        if (!node) return;
        node.setAttribute('width', String(size));
        node.setAttribute('height', String(size));
      }}
      sx={{
        height,
        width: 'auto',
        maxWidth: '100%',
        objectFit: 'contain',
        display: 'block',
        ...sx,
      }}
    />
  );
}
